import React, { useEffect } from "react";
import "..//../components/styles.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Typewriter } from 'react-simple-typewriter'

function Homepage({ notes }) {

  useEffect(() => {

    document.title =
      "Amresh Kumar | Full Stack Developer";

    const metaDescription =
      document.querySelector(
        'meta[name="description"]'
      );

    if (metaDescription) {

      metaDescription.setAttribute(
        "content",
        "Amresh Kumar is a Full Stack Developer skilled in React.js, Django, Node.js, CRM systems, ERP applications and scalable web solutions."
      );

    }

  }, []);
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,      
      easing: 'ease-in-out'
    });
  });
  return (
    <div className="wrapper-profile">
      <div className="profile wid-50">
        <img data-aos="fade-down"
          data-aos-duration="1000"
          src={`${process.env.PUBLIC_URL}/myImg.jpg`}
          onContextMenu={(e) => e.preventDefault()}
          alt="profile-pic"
        />
        <hr />
        <h2 data-aos="fade-up"
          data-aos-duration="1000">Hi, I’m <span style={{ color: '#0ef' }}>Amresh Kumar! </span></h2>
        <h2 data-aos="fade-up"
          data-aos-duration="1000">
          <Typewriter
            words={[
              'Full Stack Web Developer',
              'MERN Stack Developer',
              'React + Python + Django'
            ]}
            loop={0}
            typeSpeed={100}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h2>

      </div>
      <div className="wid-50 profile-intro arrange-left" data-aos="fade-up"
        data-aos-duration="1000">
        {notes.map((note) => (
          <h1 key={note.key}>{note.content}</h1>
        ))}
      </div>
    </div>
  );
}

export default Homepage;
